var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    gallery_photos,
    address,
    listing_id,
    ab_srp_carousel_variation,
    showCta,
    ldp_url,
    ctaText
  } = options;

  let last_photo = (gallery_photos || []).slice(-1);

__p+='\n';
 let ctaText_submit = "Contact Agent" 
__p+='\n';
 if(ctaText == 'V1') { 
__p+='\n  ';
 ctaText_submit = "Contact an Agent" 
__p+='\n';
 } 
__p+='\n\n<div class="owl-carousel owl-theme card-carousel">\n  ';
 gallery_photos.forEach(photo => { 
__p+='\n    <a href="'+
((__t=( ldp_url ))==null?'':__t)+
'">\n      <img data-src="'+
((__t=( photo ))==null?'':__t)+
'" class="owl-lazy js-srp-listing-photos" alt="'+
((__t=( address ))==null?'':__t)+
'">\n    </a>\n  ';
 }) 
__p+='\n\n  ';
 if (ab_srp_carousel_variation === 'variation_2') { 
__p+='\n    <div class="srp-card-carousel-cta text-center js-no-listing-click cta-wrap" style="background-image: linear-gradient( rgba(0,0,0,.6), rgba(0,0,0,.6) ), url('+
((__t=( last_photo ))==null?'':__t)+
');">\n      <div class="srp-card-carousel-content js-no-listing-click">\n        <p class="js-no-listing-click"> Loving what you see? <br/> Find out more about this property. </p>\n        ';
 if (showCta) { 
__p+='\n          <a class="btn btn-primary before-contact js-no-listing-click" href="javascript:void(0)" data-toggle="modal" data-target="#srp-lead-modal[listing-id=\''+
((__t=( listing_id ))==null?'':__t)+
'\']" data-omtag="srp:card_image_carousel:contact_agent">'+
((__t=( ctaText_submit ))==null?'':__t)+
'</a>\n          <a href="javascript:void(0);" class="cta-btn after-contact">Contacted</a>\n        ';
 } else { 
__p+='\n          <a class="btn btn-primary" href="javascript:void(0)">View Details</a>\n        ';
 } 
__p+='\n      </div>\n    </div>\n  ';
 } 
__p+='\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./srp/basecamp/templates/optimizely/srp_card_carousel_images.jst.ejs